import React from 'react'
import { CCol, CFormLabel, CFormSelect, CRow } from '@coreui/react-pro'

const GAME_TYPE_OPTIONS = [
  { value: 1, label: 'Club Competitions' },
  { value: 2, label: 'Leagues' },
]

// Matches the competition categories in
// src/views/pages/register/startNewGame/gameSetupConfig.js (LEAGUE_TYPE_BY_CATEGORY).
const LEAGUE_TYPE_OPTIONS = [
  { value: 1, label: 'Community League' },
  { value: 2, label: 'Association League' },
  { value: 3, label: 'Premier or State Competition' },
  { value: 4, label: 'National Tournament' },
  { value: 5, label: 'Global Tournament' },
]

const LEAGUE_GAME_TYPE = '2'

const GameType = ({ gameType, setGameType, leagueType, setLeagueType, disabled }) => {
  return (
    <CRow>
      <CCol md={12}>
        <CFormLabel className="fw-bold" htmlFor="game_type">
          Game Type *
        </CFormLabel>
        <CFormSelect
          aria-label="Select Game Type"
          name="game_type"
          id="game_type"
          value={gameType}
          onChange={(event) => setGameType(event.target.value)}
          disabled={'disabled'}
        >
          <option value={0}>Select Game Type</option>
          {GAME_TYPE_OPTIONS.map((option) => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </CFormSelect>
        {/* <small>
          <i>
            {disabled
              ? "Set when your game was created and can't be changed here."
              : 'Select the format of your fantasy game.'}
          </i>
        </small> */}
      </CCol>
      {String(gameType) === LEAGUE_GAME_TYPE && (
        <CCol md={12} className="mt-3">
          <CFormLabel className="fw-bold" htmlFor="league_type">
            League Type *
          </CFormLabel>
          <CFormSelect
            aria-label="Select League Type"
            name="league_type"
            id="league_type"
            value={leagueType || ''}
            onChange={(event) => setLeagueType(event.target.value)}
            disabled={disabled}
          >
            <option value="">Select League Type</option>
            {LEAGUE_TYPE_OPTIONS.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </CFormSelect>
        </CCol>
      )}
    </CRow>
  )
}

export default GameType
